module.exports = __webpack_public_path__ + "img/MS.a094d82f.svg";